import { configureStore } from '@reduxjs/toolkit'
import projectSlice from './project/projects'
export const store = configureStore({
  reducer: {
    projectSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})